<template>
    <div class="public-order-merchants">
        <div v-if="simplifiedView" class="public-order-merchants__links">
            <a
                v-for="(merchant, index) in merchants"
                :key="index"
                class="public-order-merchants__link pointer"
                :class="{
                    selected: selected && merchant.link === selected.link && merchant.id === selected.id
                }"
                @click="select(merchant)"
            >
                <img :src="getImage(merchant.slug, merchant.logo)" :alt="merchant.merchants_type" />
            </a>
        </div>
        <div class="mt-20" v-else>
            <div
                v-for="group in sortedMerchantsByCardType"
                :key="group.type"
                class="public-order-merchants__group mb-10"
            >
                <flex-container align="center" v-for="(merchant, mI) in group.items" :key="merchant.link + mI">
                    <div
                        class="public-order-merchants__group-merchant pointer"
                        :class="{
                            'mb-10': mI !== group.items.length - 1,
                            selected: selected && merchant.link === selected.link && merchant.id === selected.id
                        }"
                        @click="select(merchant)"
                    >
                        <img :src="getImage(merchant.slug, merchant.logo)" :alt="merchant.merchant_type" />

                        <!--  <p class="title" :class="{ 'mb-5': merchant.description }">{{ merchant.title }}</p>-->
                        <p v-if="merchant.description" class="description mt-5">{{ merchant.description }}</p>
                    </div>
                </flex-container>
            </div>
        </div>
    </div>
</template>

<script>
import FlexContainer from "@components/Containers/FlexContainer.vue"
import { PaymentImages } from "./payment-images"

const merchantTypes = {
    paypal: "paypal",
    card: "card"
}

export default {
    name: "PublicOfferOrderMerchants",
    components: { FlexContainer },
    props: {
        merchants: {
            type: Array,
            default: () => []
        },
        selected: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        images: {
            [merchantTypes.paypal]: PaymentImages[merchantTypes.paypal],
            [merchantTypes.card]: PaymentImages[merchantTypes.card]
        },
        simplifiedView: false
    }),
    computed: {
        sortedMerchantsByCardType() {
            // Complete structure
            const list = {}
            Object.values(merchantTypes).forEach(value => {
                list[value] = {
                    type: value,
                    items: []
                }
            })
            // Add merchants
            this.merchants.forEach((link, index) => {
                list[link.merchant_type].items = [...list[link.merchant_type].items, { ...link, id: index }]
            })
            // Delete merchant type without merchants
            for (const key in list) {
                if (!list[key].items.length) delete list[key]
            }
            return list
        }
    },
    created() {
        this.handleMerchantsView()
    },
    methods: {
        getImage(merchant, logo) {
            if (logo) {
                return logo
            }

            return `/build/experts/integrations/logos/${merchant}.svg`
        },
        select(merchant) {
            this.$emit("select", merchant)
        },
        handleMerchantsView() {
            this.simplifiedView = !this.merchants.find(m => m.description)
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'resources/sass/vars'
$paymentCardWidth: 160px

.public-order-merchants
    &__links
        display: grid
        grid-template-columns: repeat(2, auto)
        grid-gap: 20px
        @media (max-width: 400px)
            grid-template-columns: 1fr
    &__link
        width: auto
        height: 66px
        box-shadow: 0 4px 10px rgba(128, 158, 191, 0.15)
        border-radius: 8px
        background: #fff
        display: flex
        align-items: center
        justify-content: center
        border: 1px solid transparent
        transition: $transitionTime
        @media (max-width: 400px)
            width: 100%
        &.selected
            background: $hover-color
        &:hover,
        &.selected
            border-color: $accent-color5 !important
    img
        text-indent: 5px
        font-size: 12px
        height: 35px
        width: auto
    &__group-merchant
        padding: 13px 15px
        font-size: 13px
        flex: 1
        font-weight: 400
        line-height: 130%
        border-radius: 7px
        border: 1px solid $border-color
        transition: $transitionTime
        box-shadow: $default-shadow2
        &:hover,
        &.selected
            background: $hover-color
            border-color: $accent-color5
            .title
                color: $accent-color5
        .title
            color: $text-color
            font-weight: 600
            transition: $transitionTime
        .description
            color: $text-accent-color
</style>
